export interface BrowserGuide {
    id: string
    label: string
    /** Steps; `**bold**` marks the literal UI text to look for. */
    steps: string[]
    settingsUrl?: string
    note?: string
    video?: { src: string; poster: string }
}

/**
 * Setup walkthroughs, with the copy corrections from COPY.md applied:
 * Chrome's stray "at", Edge's `+` delimiter that broke its bolding, and
 * "your trusted providers DoH Server Url" -> "your provider's endpoint URL".
 */
export const browsers: BrowserGuide[] = [
    {
        id: 'firefox',
        label: 'Firefox',
        steps: [
            'Open the menu.',
            'Choose **Settings**.',
            'Under General, scroll to **Network Settings**.',
            'Click **Settings…**',
            'Tick **Enable DNS over HTTPS** and choose a provider, or Custom.',
            'Press **OK**.',
        ],
        settingsUrl: 'about:preferences#general',
        video: { src: '/img/doh-firefox.mp4', poster: '/img/doh-firefox.jpg' },
    },
    {
        id: 'chrome',
        label: 'Chrome',
        steps: [
            'Open the three-dot menu in the top-right corner.',
            'Choose **Settings**.',
            'Go to **Privacy and security → Security**.',
            'Turn on **Use secure DNS**.',
            'Select **With Custom** and enter your provider’s endpoint URL.',
        ],
        settingsUrl: 'chrome://settings/security',
        note: 'This may already be enabled by default.',
        video: { src: '/img/doh-chrome-windows.mp4', poster: '/img/doh-chrome-windows.jpg' },
    },
    {
        id: 'edge',
        label: 'Edge',
        steps: [
            'Go to **edge://settings/privacy**.',
            'Scroll to the **Security** section.',
            'Make sure **Use secure DNS** is enabled.',
            'Choose a suitable provider.',
        ],
        settingsUrl: 'edge://settings/privacy',
        note: 'This may already be enabled by default.',
        video: { src: '/img/doh-edge-windows.mp4', poster: '/img/doh-edge-windows.jpg' },
    },
    {
        id: 'brave',
        label: 'Brave',
        steps: [
            'Open the menu in the top-right corner.',
            'Go to **Settings**.',
            'Choose **Privacy and security**, then **Security**.',
            'Turn on **Use secure DNS**.',
            'Select **With Custom** and enter your provider’s endpoint URL.',
        ],
        settingsUrl: 'brave://settings/security',
        video: { src: '/img/doh-brave-windows.mp4', poster: '/img/doh-brave-windows.jpg' },
    },
    {
        id: 'opera',
        label: 'Opera',
        steps: [
            'Open the Opera menu.',
            'Choose Settings — or press **Alt+P** on Windows, **⌘+,** on macOS.',
            'Search for **dns** in the settings search bar.',
            'Enable **Use DNS-over-HTTPS instead of the system’s DNS settings**.',
            'Pick a provider.',
        ],
        video: { src: '/img/doh-opera-windows.mp4', poster: '/img/doh-opera-windows.jpg' },
    },
    {
        id: 'safari',
        label: 'Safari',
        steps: [
            'Safari does not support DoH directly.',
            'On macOS and iOS you can set it system-wide with a configuration profile, which applies to every app including Safari.',
        ],
    },
]
